import { BaseApi } from "./Base";

class ItemApi extends BaseApi {
  getItems(role, active, dropOff, rejected = false, past_delivered_after) {
    return super.getApiRequest("/items", { role, active, dropOff, rejected, past_delivered_after });
  }

  reviseItem(id, item) {
    return super.putApiRequest(`/items/${id}/revise`, item);
  }

  updateItem(id, action, data) {
    return super.putApiRequest(`/items/${id}`, { action, data });
  }

  batchUpdateItems(items) {
    return super.putApiRequest('/items/batch', { items });
  }

  addItem(data) {
    return super.postApiRequest(`/admin/items`, data );
  }

   deleteItem(id) {
    return super.deleteApiRequest(`/admin/items/${id}` );
  }
}

const itemApi = new ItemApi();

export default itemApi;
